// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/badge/style/index.less
// module id = 905
// module chunks = 1